<ng-template #content>
  <div *ngIf="loaded" class="identity-verification-shell" [class.mobile]="isMobileResolution">
    <section class="identity-verification-card">
      <ion-row class="identity-progress-row">
        <ng-container *ngFor="let item of progressBars">
          <ion-col class="identity-progress-bar">
            <mat-progress-bar [mode]="item.mode" [value]="item.value"></mat-progress-bar>
          </ion-col>
        </ng-container>
      </ion-row>

      <div class="identity-heading">
        <div class="identity-icon-circle">
          <tidy-image [src]="currentIdentificationStep.icon" class="identity-step-img"></tidy-image>
        </div>
        <tidy-text class="identity-step-title" [header]="currentIdentificationStep.title"></tidy-text>
        <tidy-text class="identity-step-subtitle" [body]="currentIdentificationStep.subtitle"></tidy-text>
      </div>

      <ng-container *ngIf="currentIdentificationStep === identificationSteps[0]">
        <div class="identity-warning-card">
          <div class="identity-warning-heading">
            <tidy-image [src]="'assets/svg/alert.svg'" class="identity-warning-icon"></tidy-image>
            <tidy-text [body]="'Important: For US-based users'"></tidy-text>
          </div>
          <tidy-text [body]="'A valid United States ID document is required:'"></tidy-text>
          <ul>
            <li>US-issued passport</li>
            <li>US or US state driver's license</li>
            <li>US-issued ID card</li>
          </ul>
          <tidy-text
            class="identity-warning-emphasis"
            [body]="'Non-US documents are not accepted. Uploading one will pause your account for manual review.'">
          </tidy-text>
        </div>

        <div class="identity-option-card">
          <tidy-text class="identity-option-label" [label]="'What best describes you? (Required)'"></tidy-text>

          <ng-container *ngIf="isMobileResolution">
            <ion-item lines="none" class="identity-mobile-select">
              <ion-label position="stacked">Select your ID verification option</ion-label>
              <ion-select interface="action-sheet" (ionChange)="onIdOptionChange($event.detail.value)">
                <ion-select-option value="not_in_us">Not using this in the US at all</ion-select-option>
                <ion-select-option value="valid_us_id">I'm uploading a valid US Passport, US Driver's License, or US ID Card</ion-select-option>
                <ion-select-option value="no_valid_us_id">I don't have a valid US Passport, US Driver's License, or US ID Card</ion-select-option>
              </ion-select>
            </ion-item>
          </ng-container>

          <ng-container *ngIf="!isMobileResolution">
            <tidy-select
              [label]="'Select your ID verification option'"
              [items]="[
                { viewValue: 'Not using this in the US at all', value: 'not_in_us' },
                { viewValue: 'I\'m uploading a valid US Passport, US Driver\'s License, or US ID Card', value: 'valid_us_id' },
                { viewValue: 'I don\'t have a valid US Passport, US Driver\'s License, or US ID Card', value: 'no_valid_us_id' }
              ]"
              (optionChange)="onIdOptionChange($event)">
            </tidy-select>
          </ng-container>
        </div>

        <div class="identity-error-card" *ngIf="selectedIdOption === 'no_valid_us_id'">
          <tidy-image [src]="'assets/svg/alert.svg'" class="identity-warning-icon"></tidy-image>
          <tidy-text [body]="'This is not supported at this time. Please contact concierge@tidy.com if you feel this should be supported.'"></tidy-text>
        </div>
      </ng-container>

      <ng-container *ngIf="isVideoStep">
        <tidy-row [align]="'center'" class="identity-countdown-row">
          <countdown [target]="videoDeadline"></countdown>
        </tidy-row>
        <div class="identity-video-instructions">
          <tidy-text [body]="'In about 60 seconds, tell us about:'"></tidy-text>
          <ul>
            <li>The history of your business</li>
            <li>What kind of clients you prefer</li>
            <li>Anything else about your business we might want to know</li>
          </ul>
          <tidy-text [body]="'<i>This is not shared with clients.</i>'"></tidy-text>
          <tidy-text [body]="'<b>Important:</b> Make sure we can see you and you match your ID.'"></tidy-text>
        </div>
      </ng-container>

      <tidy-row class="identity-step-button-row" [align]="'center'" *ngIf="currentIdentificationStep.displayButton">
        <tidy-button
          [text]="currentIdentificationStep.buttonText"
          [action]="currentIdentificationStep.action.bind(this)"
          class="primary">
        </tidy-button>
      </tidy-row>

      <div class="identity-result-error" *ngIf="identificationError">
        <tidy-text [body]="'<b>Verification unsuccessful.</b>'"></tidy-text>
        <tidy-text [body]="identificationError?.reason || identificationError"></tidy-text>
        <tidy-text [body]="'Verify again.'" class="link" (action)="getVerified()"></tidy-text>
      </div>

      <div class="identity-didit-badge">
        <tidy-text [body]="'Powered by'"></tidy-text>
        <tidy-image [src]="'assets/img/didit-logo.svg'" loading="eager"></tidy-image>
      </div>
    </section>
  </div>
</ng-template>

<ion-content *ngIf="isMobileResolution" class="identity-verification-content">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ion-content>

<ng-container *ngIf="!isMobileResolution">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>
